import { useQuery } from '@tanstack/react-query';
import { getNotifications } from '../api/notifications';

/**
 * Polls the role-scoped notification feed (backlog C2). The feed is derived from
 * current actionable state, so a short poll keeps the bell's unread count fresh
 * without per-item read persistence.
 */
export function useNotifications() {
  return useQuery({
    queryKey: ['notifications'],
    queryFn: getNotifications,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
  });
}
